
export enum PROMOTION_STATUS {
  VALID = 'VALID',
  INVALID = 'INVALID',
  UNDETERMINED = 'UNDETERMINED',
  LOADING = 'LOADING',
}
